






// main

import React from "react";
import { mockAuditLogs } from "../utils/mock";

const useAuditLogControllers = () => {

  // Filters
  const [filter, setFilter] = React.useState({
    search: "",
    activityType: "",
    start_date: "",
    end_date: "",
  });

  // Pagination state
  const [currentPage, setCurrentPage] = React.useState(1);
  const pageSize = 8; 

  // Filter + pagination logic for mock data
  const filteredData = React.useMemo(() => {
    // basic search filter
    if (!filter.search) return mockAuditLogs;
    return mockAuditLogs.filter((log) =>
      log.user.toLowerCase().includes(filter.search.toLowerCase())
    );
  }, [filter.search]);

  const totalPage = Math.ceil(filteredData.length / pageSize);
  const lastPage = totalPage;
  const total = filteredData.length;

  const auditLogs = React.useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return filteredData.slice(start, start + pageSize);
  }, [filteredData, currentPage]);

  return {
    // state
    filter,
    currentPage,
    pageSize,
    totalPage,
    lastPage,
    total,

    // data
    auditLogs,

    // functions
    setFilter,
    setCurrentPage,
    handleFilterChange: (key: keyof typeof filter, value: string) => {
      setFilter((prev) => ({
        ...prev,
        [key]: value,
      }));
    },
  };
};

export default useAuditLogControllers;






// hassan code


// import React from "react";
// import { useGetAuditLogsQuery } from "../redux/services/auditLog";
// import { useDebounce } from "use-debounce";

// const useAuditLogControllers = () => {
//   const [filter, setFilter] = React.useState({
//     search: "",
//     activityType: "",
//     start_date: "",
//     end_date: "",
//   });
//   // modal
//   const [showAuditLogDetails, setShowAuditLogDetails] = React.useState(false);
//   const [auditLogDetails, setAuditLogDetails] = React.useState({});

//   // pagination control
//   const [currentPage, setCurrentPage] = React.useState(1);

//   const handleFilterChange = (key: keyof typeof filter, value: string) => {
//     setFilter((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//   };

//   const handleShowAuditLog = (param: any) => {
//     setShowAuditLogDetails((prev) => !prev);
//     setAuditLogDetails(param);
//   };

//   const { search } = filter;
//   const [debouncedQuery] = useDebounce(search, 500);

//   const queryParams = React.useMemo(() => {
//     return {
//       search: debouncedQuery,
//       page: currentPage,
//     };
//   }, [debouncedQuery, currentPage]);

//   // all audit-log data
//   const { data, isLoading, isFetching } = useGetAuditLogsQuery(queryParams);

//   const auditLogs = data?.data?.data || [];
//   const pageSize = data?.data?.meta?.per_page;
//   const totalPage = data?.data?.meta?.total;
//   const lastPage = data?.data?.meta?.last_page;

//   return {
//     // state
//     filter,
//     pageSize,
//     totalPage,
//     lastPage,
//     isLoading,
//     isFetching,
//     currentPage,
//     showAuditLogDetails,
//     auditLogDetails,

//     // data
//     auditLogs,

//     // function
//     setFilter,
//     setCurrentPage,
//     handleFilterChange,
//     handleShowAuditLog,
//     setShowAuditLogDetails,
//   };
// };
// export default useAuditLogControllers;







